import ChatIcon from '@mui/icons-material/Chat'
import ColorLensIcon from '@mui/icons-material/ColorLens'
import DashboardIcon from '@mui/icons-material/Dashboard'
import FeedbackIcon from '@mui/icons-material/Feedback'
import FolderCopyIcon from '@mui/icons-material/FolderCopy'
import Foundation from '@mui/icons-material/Foundation'
import HandymanIcon from '@mui/icons-material/Handyman'
import KeyIcon from '@mui/icons-material/Key'
import LogoutIcon from '@mui/icons-material/Logout'
import PaletteIcon from '@mui/icons-material/Palette'
import PaymentIcon from '@mui/icons-material/Payment'
import PreviewIcon from '@mui/icons-material/Preview'
import SettingsIcon from '@mui/icons-material/Settings'
import WebIcon from '@mui/icons-material/Web'

const icons = {
  ColorLensIcon,
  ChatIcon,
  DashboardIcon,
  FolderCopyIcon,
  Foundation,
  HandymanIcon,
  KeyIcon,
  LogoutIcon,
  PaletteIcon,
  PaymentIcon,
  PreviewIcon,
  SettingsIcon,
  WebIcon,
  FeedbackIcon,
}

export interface MenuBase {
  id: string
  title: string
  url?: string
  onClick?: () => void
}

export interface MenuGroup extends MenuBase {
  type: 'group'
  icon: React.ElementType
  children: MenuItem[]
}

export interface MenuItem extends MenuBase {
  type: 'item'
  icon?: React.ElementType
  breadcrumbs?: boolean
  external?: boolean
}

const settings: MenuGroup = {
  id: 'settings',
  title: 'Settings',
  url: '/settings/subscription',
  type: 'group',
  icon: icons.SettingsIcon,
  children: [],
}

const content: MenuGroup = {
  id: 'content',
  title: 'Fine-tune responses',
  url: '/web-concierge/content',
  type: 'group',
  icon: icons.FolderCopyIcon,
  children: [],
}

const venue: MenuGroup = {
  id: 'venue',
  title: 'Manage Venue',
  url: '/web-concierge/venue',
  type: 'group',
  icon: icons.Foundation,
  children: [],
}

const conversations: MenuGroup = {
  id: 'conversations',
  title: 'See user inquiries',
  url: '/web-concierge/conversations',
  type: 'group',
  icon: icons.ChatIcon,
  children: [],
}

const feedback: MenuGroup = {
  id: 'feedback',
  title: 'View Feedback',
  url: '/settings/feedback',
  type: 'group',
  icon: icons.FeedbackIcon,
  children: [],
}

const adminDashboard: MenuGroup = {
  id: 'adminDashboard',
  title: 'AdminDashboard',
  url: '/settings/admin-dashboard',
  type: 'group',
  icon: icons.KeyIcon,
  children: [],
}

const customize: MenuGroup = {
  id: 'customize',
  title: 'Customize look & feel',
  url: '/web-concierge/customize',
  type: 'group',
  icon: icons.ColorLensIcon,
  children: [],
}

const preview: MenuGroup = {
  id: 'preview',
  title: 'Preview',
  url: '/web-concierge/preview',
  type: 'group',
  icon: icons.PreviewIcon,
  children: [],
}

const menuLinks = {
  items: [
    content,
    venue,
    customize,
    preview,
    conversations,
    settings,
    feedback,
    adminDashboard,
  ],
}

export default menuLinks
